

function hasCredits(credit: any) {
    if (!credit) return false
    return Boolean((!!credit.credits_left && credit.credits_left > 0) || (!!credit.credits_bought && credit.credits_bought > 0))
}

export {
    hasCredits
}